/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { useState } from 'react';
import { useMutateUserProfile } from '../../hooks/api/useUserProfile';
import uploadToS3Bucket from '../../utils/uploadToS3Bucket';
import Modal from '../../components/modal/Modal';
import useModal from '../../hooks/useModal';
import AlertCustom from '../../components/alert/AlertCustom';
import Button from '../../components/button/Button';
import FormEditIntro from './FormEditIntro';
import FormEditAbout from './FormEditAbout';

const useEditIntroAbout = () => {
    const [isIntroAbout, closeIntroAbout, openIntroAbout] = useModal(false);
    const [alertSuccess, closeAlertSuccess, openAlertSuccess] = useModal();
    const [valuesIntro, setValuesIntro] = useState({});
    const [step, setStep] = useState(0);

    const {
        mutate,
        // error,
        isLoading: isPostLoading
        // isSuccess
    } = useMutateUserProfile();

    const [resumeFile, setResumeFile] = useState(null);
    const [uploadingResume, setUploadingResume] = useState(false);

    const submitData = values => {
        values.boardDirectors =
            values.boardDirectors === '1' || values.boardDirectors === true;
        values.vendorOffers =
            values.vendorOffers === '1' || values.vendorOffers === true;
        values.privateEmail =
            values.privateEmail === '1' || values.privateEmail === true;
        values.privatePhone =
            values.privatePhone === '1' || values.privatePhone === true;
        values = {
            ...valuesIntro,
            ...values
        };
        console.log('SUBMITTING DATA AFTER', values);
        mutate(values, {
            onError: err => {
                console.log('MUTATE FAILED', err);
            },
            onSuccess: () => {
                setTimeout(() => {
                    closeIntroAbout();
                    openAlertSuccess();
                }, 300);
            }
        });
    };

    const handleSubmit = values => {
        // We set resume to null because we have a file uploaded in input#resume
        // but we want to save only its location on S3
        values.resume = null;
        // if user added a rseume, we upload it before mutating user data
        if (resumeFile) {
            setUploadingResume(true);
            uploadToS3Bucket(resumeFile)
                .then(data => {
                    values.resume = data.location;
                })
                .catch(err => console.error('error uploading', err))
                .finally(() => {
                    setUploadingResume(false);
                    submitData(values);
                });
        } else {
            submitData(values);
        }
    };

    const submitIntro = values => {
        setValuesIntro(values);
        setStep(1);
    };

    const isUploadingAndSaving = isPostLoading || uploadingResume;
    const modalProps = {
        isIntroAbout,
        closeIntroAbout,
        isUploadingAndSaving,
        handleSubmit,
        setResumeFile,
        alertSuccess,
        closeAlertSuccess,
        submitIntro,
        step
    };

    const IntroAboutJSX = <ModalIntroAbout {...modalProps} />;

    return [openIntroAbout, IntroAboutJSX];
};

export default useEditIntroAbout;

const ModalIntroAbout = ({
    isIntroAbout,
    closeIntroAbout,
    isUploadingAndSaving,
    handleSubmit,
    setResumeFile,
    alertSuccess,
    closeAlertSuccess,
    submitIntro,
    step
}) => {
    const renderStepFrom = () => {
        switch (step) {
            case 0:
                return (
                    <FormEditIntro
                        isUploadingAndSaving={isUploadingAndSaving}
                        handleSubmit={submitIntro}
                        setResumeFile={setResumeFile}
                        btnText={'Next'}
                    />
                );
            case 1:
                return (
                    <FormEditAbout
                        handleSubmit={handleSubmit}
                        isPostLoading={isUploadingAndSaving}
                    />
                );
            default:
                return <div>...</div>;
        }
    };

    return (
        <>
            <Modal
                showModal={isIntroAbout}
                closeModal={closeIntroAbout}
                btnCloseModal={false}
                position="p-top"
                width="modal-md">
                {renderStepFrom()}
            </Modal>
            <AlertCustom
                showModal={alertSuccess}
                title="Saved successfully"
                subtitle="Information has been saved successfully"
                typeAlert="success">
                <>
                    <Button
                        classs="btnMain"
                        text="Ok"
                        onClick={() => {
                            closeAlertSuccess();
                        }}
                    />
                </>
            </AlertCustom>
        </>
    );
};
